import type { StatePatch } from './types.ts';

export interface Plate extends StatePatch {
  id: string;
  label: string;
  note: string;
}

// Named plates: a complete state, so a figure that took a while to dial in
// can be recovered exactly rather than reconstructed from memory.
export const PLATES: Plate[] = [
  {
    id: 'lonestar',
    label: 'Lone Star',
    note: 'penrose d8 ribbon · red/white/blue mirrored · rot 0.375 · black',
    curve: 'penrosecurve',
    exportId: 'penrose_d8_ribbon',
    stops: ['#ff0000', '#ffffff', '#0000ff'],
    closure: 'mirror',
    rotation: 0.375,
    repeat: 1,
    reverse: false,
    hard: false,
    pingpong: true,
    autoCycles: false,
    colorMode: 'roygbiv',
    bgHex: '#000000',
    solidHex: '#ffffff',
    width: 1.2,
    aspect: 0,
  },
];
